module.exports = __webpack_public_path__ + "static/img/ic_bottom_viewmore_on@2x.c53480d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bottom_viewmore_on@2x.png
// module id = loA4
// module chunks = 1